import React from 'react';
import { cn } from '@/lib/utils';

interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  className?: string;
  id?: string;
  name?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  className,
  id,
  name,
}) => {
  return (
    <div className="relative">
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={cn(
          'h-4 w-4 rounded border border-input bg-background text-primary focus:ring-ring focus:ring-2',
          'dark:border-input dark:bg-muted dark:text-primary',
          disabled && 'opacity-50 cursor-not-allowed',
          className
        )}
      />
    </div>
  );
};
